import styled from "styled-components";

const ButtonContainer = styled.div`
  width: 100%;
  display: grid;
`;

export default ButtonContainer;
